import { render } from "./IconSearch.vue?vue&type=template&id=174e0023"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconSearch.vue"]])

export default __exports__